import React from 'react';
import Icon from '../BaseComponentWrappers/MotifIcon';
import styled from 'styled-components';
import {IconoirArrowDown, IconoirArrowUp} from '@ey-xd/motif-icon';
import {applyRound} from '@ey/utils';
import {isNullOrUndefined} from '../../../util/utils';

export default function BalanceArrow(params) {
	return (
		<StyledBalanceArrow className="StyledBalanceArrow">
			{!isNullOrUndefined(params.value) && (
				<>
					<section className="PercentageLabels">{applyRound(params.value, 1) + '%'}</section>
					{params.value > 0 ? (
						<Icon className="balance-green-arrow" src={IconoirArrowUp} />
					) : params.value < 0 ? (
						<Icon className="balance-red-arrow" src={IconoirArrowDown} />
					) : (
						<span className="empty" />
					)}
				</>
			)}
		</StyledBalanceArrow>
	);
}

const StyledBalanceArrow = styled.section`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	font-size: var(--px-12);
	font-weight: 400;
	line-height: var(--px-22);
	.PercentageLabels {
		width: auto;
		max-width: calc(100% - var(--px-20));
		display: inline-flex;
		justify-content: flex-end;
		&.balanceGreen {
			color: var(--green-300) !important;
		}
		&.balanceRed {
			color: var(--red-400) !important;
		}
	}
	.empty {
		display: inline-flex;
		width: var(--px-16);
		margin: 0 0 0 var(--px-4);
	}
	.motif-icon {
		display: inline-flex;
		width: var(--px-16);
		margin: 0 0 0 var(--px-4);
		&.balance-red-arrow {
			svg {
				color: var(--red-400);
				fill: none;
			}
		}
		&.balance-green-arrow {
			svg {
				color: var(--green-300);
				fill: none;
			}
		}
		svg {
			height: var(--px-16) !important;
			width: var(--px-16) !important;
			cursor: default !important;
			vertical-align: middle;
		}
	}
`;
